var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flag',{class:_vm.styles,attrs:{"iso":_vm.isoCode,"squared":false}})}
var staticRenderFns = []

export { render, staticRenderFns }